import React from 'react';
import { LargeHeading } from '@/components/Views/Heading';
import { NormalText } from '@/components/Views/Text';

interface Props {
    heading?: string;
    id?: string;

    infoItems?: any;

}

export const LanaBob = ({ heading, infoItems, id }: Props) => (
    <section id={id} className='font-Inter'>
        <div className='lana-bob default-px'>
            <div className='lana-bob--wrapper default-max-w'>
                <LargeHeading heading={heading} className='lg:text-center text-center max-w-[800px]' />
                <div className='lana-bob--content'>
                    <div className='lana-bob--content-child'>
                        <div className='lana-bob--photo-wrapper' style={{ backgroundImage: 'url(\'/assets/graphics/ellipse-3.svg\')' }}>
                            <div className='lana-bob--photo-container'>
                                <img className='lana-bob--photo  h-[100%] w-auto h-[40%]' src='/assets/graphics/lana-avatar.png' alt='Lana Israel' />
                            </div>
                        </div>
                        <p className='lana-bob--name'>{infoItems[0].header}</p>
                        <p className='lana-bob--job'>{infoItems[0].subheader}</p>
                        <NormalText>{infoItems[0].text}</NormalText>
                    </div>
                    <div className='lana-bob--content-child'>
                        <div className='lana-bob--photo-wrapper' style={{ backgroundImage: 'url(\'/assets/graphics/ellipse-4.svg\')' }}>
                            <div className='lana-bob--photo-container'>
                                <img className='lana-bob--photo' src='/assets/graphics/bob-avatar.png' alt='Bob Doyle' />
                            </div>
                        </div>
                        <p className='lana-bob--name'>{infoItems[1].header}</p>
                        <p className='lana-bob--job'>{infoItems[1].subheader}</p>
                        <NormalText>
                            {infoItems[1].text}
                        </NormalText>
                    </div>
                </div>
            </div>
            <style jsx>{`
                .lana-bob {
                    width: 100%;
                    background: #fff;

                    .lana-bob--wrapper {
                        margin: 0 auto;

                        .lana-bob--content {
                            display: flex;
                            justify-content: center;
                            margin: 50px 0 0;

                            .lana-bob--content-child {
                                flex: 1;
                                height: inherit;
                                padding: 0 35px;

                                &:first-child {
                                    padding-left: 0;
                                }

                                &:last-child {
                                    padding-right: 0;
                                }

                                .lana-bob--photo-wrapper {
                                    background-size: contain;
                                    background-repeat: no-repeat;
                                    background-position: center;
                                    display: flex;
                                    align-items: stretch;
                                    justify-content: center;

                                    .lana-bob--photo-container {
                                        padding-left: 10px;
                                        padding-right: 0px;
                                        padding-top: 0px;
                                        padding-bottom: 10px;

                                        .lana-bob--photo {
                                            height: 100%;
                                            //height: auto;
                                            //width: 100%;
                                            width: auto;
                                        }
                                    }

                                }

                                .lana-bob--name {
                                    font-weight: 800;
                                    font-size: 36px;
                                    line-height: 110%;
                                    text-align: center;
                                    color: #121651;
                                    margin: 23px 0 0;
                                }

                                .lana-bob--job {
                                    font-weight: 800;
                                    font-size: 24px;
                                    line-height: 28px;
                                    text-align: center;
                                    background: -webkit-linear-gradient(135deg, #e637a8 2.69%, #e68137 75%);
                                    -webkit-background-clip: text;
                                    -webkit-text-fill-color: transparent;
                                    max-width: 428px;
                                    margin: 18px auto 0;
                                }

                                .lana-bob--description {
                                    font-weight: 300;
                                    font-size: 16px;
                                    line-height: 24px;
                                    color: #4f4f4f;
                                    margin: 38px 0 0;
                                }
                            }
                        }
                    }

                    @media (max-width: 992px) {
                        padding: 48px 40px;
                    }

                    @media (max-width: 768px) {
                        .lana-bob--wrapper {
                            .lana-bob--title {
                                font-size: 36px;
                            }

                            .lana-bob--content {
                                flex-direction: column;
                                margin-top: 15px;

                                .lana-bob--content-child {
                                    padding: 35px 0;

                                    &:first-child {
                                        padding-top: 0;
                                    }

                                    &:last-child {
                                        padding-bottom: 0;
                                    }

                                    .lana-bob--name {
                                        font-size: 28px;
                                    }

                                    .lana-bob--job {
                                        font-size: 20px;
                                    }

                                    .lana-bob--description {
                                        font-size: 16px;
                                        margin-top: 20px;
                                    }
                                }
                            }
                        }
                    }

                    @media (max-width: 480px) {
                        padding: 48px 20px;
                    }
                }
            `}</style>
        </div>
    </section>
);
